import { useEffect } from 'react';
import { useAppSelector } from '../../../hooks';
import { selectCurrentTrials, selectCurrentTrialsStatus } from '../../../selectors';
import { useExperiments } from '../../../hooks/useNavConfig';
import { getExperimentGroup } from '../../../laboratory';
import { RequestStatus } from '../../../interface';
import { MINI_TRIAL_GUIDE_COMPONENT } from 'navigation-components/config';
import { useToggleComponent } from 'navigation-components/platform/hooks';
import { getMiniTrialGuideOpenFromStorage, removeMiniTrialGuideStateFromStorage } from '../../../external-contrib/growth-trials/utils/localStorage';
export const useMiniTrialGuide = () => {
  const {
    toggle: delayedToggle
  } = useToggleComponent(MINI_TRIAL_GUIDE_COMPONENT, {
    useScheduler: true
  });
  const trials = useAppSelector(selectCurrentTrials);
  const trialsStatus = useAppSelector(selectCurrentTrialsStatus);
  const experiments = useExperiments();
  const experimentGroup = getExperimentGroup('hc-0134', experiments);
  const shouldRenderMiniTrialGuide = trialsStatus === RequestStatus.SUCCESS && trials.length > 0 &&
  // Change experimentGroup to 'control' to see the mini trial guide
  experimentGroup === 'variation';
  useEffect(() => {
    if (trialsStatus === RequestStatus.SUCCESS) {
      if (shouldRenderMiniTrialGuide && getMiniTrialGuideOpenFromStorage()) {
        delayedToggle(true);
      } else {
        try {
          removeMiniTrialGuideStateFromStorage();
        } catch (error) {
          console.error(error);
        }
      }
    }
  }, [shouldRenderMiniTrialGuide, trialsStatus, delayedToggle]);
  return shouldRenderMiniTrialGuide;
};